import _ from 'lodash'

export const FIELDS = {
  required_PIN: {
    field: 'required_PIN',
    type: 'string'
  },
  phone_number: {
    field: 'phone_number',
    type: 'string'
  },
  original_amount: {
    field: 'original_amount',
    type: 'number',
    validation: (v) => v >= 1
  },
  original_amount: {
    field: 'customer_id',
    type: 'number'
  },
  recipient_number: {
    field: 'recipient_number',
    type: 'string'
  }
}

const DEFAULT_MODEL = [
  FIELDS.phone_number,
  FIELDS.original_amount,
  FIELDS.customer_id
];

export function getData(getStore, extraModel = null) {
  const applicationData = getStore().app && getStore().app.x_data;
  if(!applicationData) {
    console.error('ApplicationData not found');
    return false;
  }

  const MODEL = _.compact(_.concat(DEFAULT_MODEL, extraModel));
  const result = {};

  _.each(MODEL, (o) => {
    result[o.field] = applicationData[o.field];
  });

  return result;
}

export function validator(getStore, extraModel = null) {
  const applicationData = getStore().app && getStore().app.x_data;
  if(!applicationData) {
    console.error('ApplicationData not found');
    return false;
  }

  const MODEL = _.compact(_.concat(DEFAULT_MODEL, extraModel));

  const result = _.reduce(MODEL, (prevStep, nextStep) => {
    const value = applicationData[nextStep.field];
    const extraValidation =  nextStep.validation ? nextStep.validation(value) : true;

    const isValid = !!(value && typeof value === nextStep.type && extraValidation);

    return prevStep && isValid
  }, true);
  return result
}



// WEBPACK FOOTER //
// ./src/components/Applications/PhonereloadEzBill/models/transaction.js